import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { getLabelForGoodsType } from './label-for-goods-type';

import {
  LithiumMetalBatteriesContainedInEquipment,
  LithiumMetalBatteriesPackedWithEquipment,
  LithiumMetalBatteriesStandAlone,
  LithiumIonBatteriesContainedInEquipment,
  LithiumIonBatteriesPackedWithEquipment,
  LithiumIonBatteriesStandAlone,
  LimitedQuantity,
  SmallQuantityProvision,
} from '../../../../../../src/orders/other-shipping-options/constants/dhl-ecommerce/dangerous-goods-domestic';

const types = [
  LithiumMetalBatteriesContainedInEquipment,
  LithiumMetalBatteriesPackedWithEquipment,
  LithiumMetalBatteriesStandAlone,
  LithiumIonBatteriesContainedInEquipment,
  LithiumIonBatteriesPackedWithEquipment,
  LithiumIonBatteriesStandAlone,
  LimitedQuantity,
  SmallQuantityProvision,
];

export const GoodsTypeDomestic = ({ onDomesticChange }) => {
  return types.map((goodsType) => (
    <DropdownMenuItem key={goodsType} name={goodsType} onClick={onDomesticChange}>
      {getLabelForGoodsType(goodsType)}
    </DropdownMenuItem>
  ));
};

GoodsTypeDomestic.propTypes = {
  onDomesticChange: PropTypes.func.isRequired,
};
